// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._9MRr{--wpp-modal-vertical-position-minus-number: 0%}`, "",{"version":3,"sources":["webpack://./src/components/Modals/UploadProjectData/UploadProjectData.module.scss"],"names":[],"mappings":"AACA,OACE,8CAAA","sourcesContent":["@import \"/home/runner/work/commerce-studio/commerce-studio/apps/commerce-studio/src/styles/shared/utils.scss\";\n.modalReposition {\n  --wpp-modal-vertical-position-minus-number: 0%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalReposition": `_9MRr`
};
export default ___CSS_LOADER_EXPORT___;
